import { useEffect, useRef } from 'react';
import { eventBus } from 'services/eventBus';

export interface UseMessageEditorEventBusParams {
  conversationId: string;
  setInput: (conversationId: string, value: string) => void;
  onSend?: () => void;
  focus: () => void;
  setUpdateDraftCallbackRef: (value: boolean) => void;
}

/**
 * 消息编辑器事件总线订阅
 * 单一职责：订阅 ON_SEND_MESSAGE、UPDATE_DRAFT、MESSAGE_EDITOR_FOCUS，使用 ref 保持最新回调
 */
export function useMessageEditorEventBus(params: UseMessageEditorEventBusParams) {
  const { conversationId, setInput, onSend, focus, setUpdateDraftCallbackRef } = params;

  const refsCurrent = { setInput, onSend };
  const refs = useRef(refsCurrent);
  refs.current = refsCurrent;

  useEffect(() => {
    const onSendMessageHandler = () => {
      refs.current.onSend?.();
    };
    const updateDraftHandler = (text: string) => {
      refs.current.setInput(conversationId, text);
      setUpdateDraftCallbackRef(true);
      focus();
    };

    eventBus.on('ON_SEND_MESSAGE', onSendMessageHandler);
    eventBus.on('UPDATE_DRAFT', updateDraftHandler);
    eventBus.on('MESSAGE_EDITOR_FOCUS', focus);

    return () => {
      eventBus.off('ON_SEND_MESSAGE', onSendMessageHandler);
      eventBus.off('UPDATE_DRAFT', updateDraftHandler);
      eventBus.off('MESSAGE_EDITOR_FOCUS', focus);
    };
  }, [conversationId, setUpdateDraftCallbackRef, focus]);
}
